module.exports = __webpack_public_path__ + "img/PDPA-2.56b75548.png";